module.exports = __webpack_public_path__ + "img/manage-assets.b9b41d53.png";